import React from "react"
import { Redirect } from "react-router-dom"

// // Authentication related pages
const Login = React.lazy(() => import("../pages/Authentication/Login"))
const Logout = React.lazy(() => import("../pages/Authentication/Logout"))
const Register = React.lazy(() => import("../pages/Authentication/Register"))
const ForgetPwd = React.lazy(() => import("../pages/Authentication/ForgetPassword"))

// Admin Dashboard
const AdminDashboard = React.lazy(() => import("../admin/dashboard/index"))
const AdminChangePassword = React.lazy(() => import("../admin/account/index"))
const AdminDeals = React.lazy(() => import("../admin/deals/index"))
const AdminDealsView = React.lazy(() => import("../admin/deals/view"))
const AdminDealsCreate = React.lazy(() => import("../admin/deals/create"))
const AdminLiquidityPools = React.lazy(() => import("../admin/liquidity/index"))
const AdminUsers = React.lazy(() => import("../admin/users/index"))
const AdminUserView = React.lazy(() => import("../admin/users/view"))
const AdminUserEdit = React.lazy(() => import("../admin/users/edit"))
const AdminBranches = React.lazy(() => import("../admin/branches/index"))
const AdminBranchCreate = React.lazy(() => import("../admin/branches/create"))
const AdminBranchView = React.lazy(() => import("../admin/branches/view"))
const AdminProducts = React.lazy(() => import("../admin/products/index"))
const AdminProductCreate = React.lazy(() => import("../admin/products/create"))
const AdminProductView = React.lazy(() => import("../admin/products/view"))
const AdminNews = React.lazy(() => import("../admin/news/index"))
const AdminNewsCreate = React.lazy(() => import("../admin/news/create"))
const AdminNewsView = React.lazy(() => import("../admin/news/view"))
const AdminSupportFeedback = React.lazy(() => import("../admin/support/index"))
const AdminTransactions = React.lazy(() => import("../admin/transactions/index"))
const AdminOrders = React.lazy(() => import("../admin/orders/index"))
const AdminDepositRequests = React.lazy(() => import("../admin/deposit_requests/index"))
const AdminSubAdmin = React.lazy(() => import("../admin/sub-admin/index"))
const AdminSubAdminCreate = React.lazy(() => import("../admin/sub-admin/create"))
const AdminBranchOwners = React.lazy(() => import("../admin/branchowner/index"))
const AdminBranchOwnerCreate = React.lazy(() => import("../admin/branchowner/create"))
const AdminBanks = React.lazy(() => import("../admin/banks/index"))
const AdminBankCreate = React.lazy(() => import("../admin/banks/create"))
const AdminGifts = React.lazy(() => import("../admin/gifts/index"))
const AdminWithdrawalRequests = React.lazy(() => import("../admin/withdrawal_requests/index"))
const AdminReferralBonus = React.lazy(() => import("../admin/referral_bonus/index"))
const AdminGroupMarkup = React.lazy(() => import("../admin/commissions/index"))
const AdminPayoutBanks = React.lazy(() => import("../admin/payout-banks/index"))
const AdminPayoutBankCreate = React.lazy(() => import("../admin/payout-banks/create"))

// General
const ContentManagement = React.lazy(() => import("../admin/cms"))
const AdminFAQ = React.lazy(() => import("../admin/faq/index"))

// Settings
const AdminCustomization = React.lazy(() => import("../admin/settings/customization/index"))

const authProtectedRoutes = [

  // Admin Routes
  { path: "/admin/dashboard", component: AdminDashboard, exact: true },
  { path: "/admin/change-password", component: AdminChangePassword, exact: true },

  { path: "/admin/users", component: AdminUsers, exact: true },
  { path: "/admin/users/view", component: AdminUserView, exact: true },
  { path: "/admin/users/edit", component: AdminUserEdit, exact: true },

  { path: "/admin/deals", component: AdminDeals, exact: true },
  { path: "/admin/deals/view", component: AdminDealsView, exact: true },
  { path: "/admin/deals/create", component: AdminDealsCreate, exact: true },
  { path: "/admin/liquidity-pools", component: AdminLiquidityPools, exact: true },
  { path: "/dashboard", component: AdminDashboard, exact: true },

  // Sub-Admin Management
  { path: "/admin/sub-admin", component: AdminSubAdmin, exact: true },
  { path: "/admin/sub-admin/create", component: AdminSubAdminCreate, exact: true },
  { path: "/admin/sub-admin/edit", component: AdminSubAdminCreate, exact: true },

  // Branch Owner Management
  { path: "/admin/branch-owners", component: AdminBranchOwners, exact: true },
  { path: "/admin/branch-owners/create", component: AdminBranchOwnerCreate, exact: true },
  { path: "/admin/branch-owners/edit", component: AdminBranchOwnerCreate, exact: true },

  // Branch Management
  { path: "/admin/branches", component: AdminBranches, exact: true },
  { path: "/admin/branches/create", component: AdminBranchCreate, exact: true },
  { path: "/admin/branches/view", component: AdminBranchView, exact: true },

  // Product Management
  { path: "/admin/products", component: AdminProducts, exact: true },
  { path: "/admin/products/create", component: AdminProductCreate, exact: true },
  { path: "/admin/products/view", component: AdminProductView, exact: true },

  // Transaction Management
  { path: "/admin/transactions", component: AdminTransactions, exact: true },
  { path: "/admin/orders", component: AdminOrders, exact: true },

  // Deposit Requests Management
  { path: "/admin/deposit-requests", component: AdminDepositRequests, exact: true },

  // News Management
  { path: "/admin/news", component: AdminNews, exact: true },
  { path: "/admin/news/create", component: AdminNewsCreate, exact: true },
  { path: "/admin/news/view", component: AdminNewsView, exact: true },

  // Support & Feedback
  { path: "/admin/support-feedback", component: AdminSupportFeedback, exact: true },

  // General
  { path: "/admin/cms", component: ContentManagement, exact: true },
  { path: "/admin/faq", component: AdminFAQ, exact: true },

  // Settings
  { path: "/admin/customization", component: AdminCustomization, exact: true },

  // Bank Management
  { path: "/admin/banks", component: AdminBanks, exact: true },
  { path: "/admin/banks/create", component: AdminBankCreate, exact: true },
  { path: "/admin/banks/edit", component: AdminBankCreate, exact: true },

  // Gift Management
  { path: "/admin/gifts", component: AdminGifts, exact: true },

  // Withdrawal Requests Management
  { path: "/admin/withdrawal-requests", component: AdminWithdrawalRequests, exact: true },

  // Payout Banks Management
  { path: "/admin/payout-banks", component: AdminPayoutBanks, exact: true },
  { path: "/admin/payout-banks/create", component: AdminPayoutBankCreate, exact: true },
  { path: "/admin/payout-banks/edit", component: AdminPayoutBankCreate, exact: true },

  // Referral Bonus Management
  { path: "/admin/referral-bonus", component: AdminReferralBonus, exact: true },

  // Commission Management
  { path: "/admin/group-markup", component: AdminGroupMarkup, exact: true },

  { path: "/", exact: true, component: () => <Redirect to="/login" /> },
]

const publicRoutes = [

  { path: "/logout", component: Logout, exact: true },
  { path: "/login", component: Login, exact: true },
  { path: "/forgot-password", component: ForgetPwd, exact: true },
  { path: "/register", component: Register, exact: true },

]

export { authProtectedRoutes, publicRoutes }
